import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Sidebar from "./Sidebar";
import { Toaster } from "./ui/sonner";
import AkilFloatingWidget from "./ai/AkilFloatingWidget";
import { UserProfileMenu } from "./UserProfileMenu";
import LiveNotificationCenter from "./LiveNotificationCenter";
import WhatsAppNotificationCenter from "./WhatsAppNotificationCenter";

export default function Layout() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();

    React.useEffect(() => {
        setMobileOpen(false);
    }, [location.pathname]);

    return (
        <div className="min-h-screen flex bg-[#0B0F19] text-slate-100">
            {/* Desktop sidebar */}
            <div className="hidden lg:block">
                <Sidebar />
            </div>

            {/* Mobile sidebar */}
            {mobileOpen && (
                <>
                    <div
                        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[240] lg:hidden"
                        onClick={() => setMobileOpen(false)}
                    />
                    <Sidebar onNavigate={() => setMobileOpen(false)} />
                </>
            )}

            <main className="flex-1 min-w-0 flex flex-col">
                {/* Desktop top bar — profil sağ üst */}
                <div className="hidden lg:flex items-center justify-between px-6 h-14 border-b border-white/10 bg-[#0B0F19]/80 backdrop-blur-xl sticky top-0 z-20">
                    <div className="text-sm text-slate-500 tracking-wide">
                        MBS Hukuk · Yönetim Paneli
                    </div>
                    <div className="flex items-center gap-2">
                        <WhatsAppNotificationCenter />
                        <LiveNotificationCenter />
                        <UserProfileMenu variant="header" />
                    </div>
                </div>

                {/* Mobile top bar */}
                <div className="lg:hidden flex items-center justify-between px-4 h-14 border-b border-white/10 bg-[#0B0F19]/80 backdrop-blur-xl sticky top-0 z-[230]">
                    <button
                        data-testid="mobile-menu-button"
                        onClick={() => setMobileOpen((v) => !v)}
                        className="h-9 w-9 rounded-md hover:bg-white/5 flex items-center justify-center text-slate-300"
                    >
                        {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                    </button>
                    <div className="font-display text-lg gold-text">MBS Hukuk</div>
                    <div className="flex items-center gap-1">
                        <WhatsAppNotificationCenter />
                        <UserProfileMenu variant="header" />
                    </div>
                </div>

                <div className="flex-1">
                    <Outlet />
                </div>
            </main>

            <Toaster
                theme="dark"
                position="top-right"
                toastOptions={{
                    style: {
                        background: "#121A2F",
                        border: "1px solid rgba(255,255,255,0.08)",
                        color: "#F8FAFC",
                    },
                }}
            />

            <AkilFloatingWidget />
        </div>
    );
}
